import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LogsNav } from 'src/app/interfaces/interfaces.index';
import { Petition } from 'src/app/interfaces/petition';
import { LogsService, UserService } from 'src/app/services/services.index';

@Component({
  selector: 'app-proceso-adjudicado-cancelado',
  templateUrl: './proceso-adjudicado-cancelado.component.html',
  styleUrls: ['./proceso-adjudicado-cancelado.component.css']
})
export class ProcesoAdjudicadoCanceladoComponent implements OnInit {

  currentPetition: Petition;

  constructor(private router: Router,
    private logsService: LogsService,
    private userService: UserService) {
    this.currentPetition = (JSON.parse(sessionStorage.getItem('selPetition'))) as Petition;
  }

  ngOnInit(): void {
    this.addLogsNav();
  }

  addLogsNav(){
    const logNav: LogsNav = {
      logType: 'Log de Navegación',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: 0,
      stepCompleted: ''
    };

  }

  cancelProcess() {
    switch(this.currentPetition.processId) {
      case 10:
        this.router.navigate(['/desistir-nominacion']);
        break;
      default:
        this.router.navigate(['/opciones-capacidad-pago']);
        break;
    }
  }

  continueProcess() {
    switch(this.currentPetition.processId) {
      case 10:
        this.router.navigate(['seleccion-vehiculo']);
        break;
      default:
        this.router.navigate(['proceso']);
        break;
    }
  }

}
